(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pivot-responsive-video"] && !Shopify.designMode) return;
  try {
    class PivotResponsiveVideo extends HTMLElement {
    connectedCallback() {
      console.log('VIDEO RESPONSIVE');
      this.desktopVideo = this.querySelector('.pivot-desktop-video');
      this.mobileVideo = this.querySelector('.pivot-mobile-video');
      this.responsivePlay();
      window.addEventListener('resize', this.responsivePlay);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.responsivePlay);
    }
    responsivePlay = () => {
      if (window.innerWidth > 750) {
        if (this.desktopVideo) this.desktopVideo.play();
        if (this.mobileVideo) this.mobileVideo.pause();
      } else {
        if (this.desktopVideo) this.desktopVideo.pause();
        if (this.mobileVideo) this.mobileVideo.play();
      }
    };
  }
  if (!customElements.get('pivot-responsive-video')) {
    customElements.define('pivot-responsive-video', PivotResponsiveVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pivot-slideshow-controls"] && !Shopify.designMode) return;
  try {
    class PivotCarouselControlsWrapper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.isConnected) return;
      this.slider = this.closest('slideshow-component');
      this.slider.addEventListener('slideshow:select', (e) => {
        const index = e.detail.index;
        this.querySelector('.slideshow-control[aria-selected="true"]')?.setAttribute('aria-selected', 'false');

        const columns = parseInt(this.getAttribute('columns')) || 1;
        const columnsMb = parseInt(this.getAttribute('columns-mb')) || 1;
        const pageIndexDesktop = Math.floor(index / columns);
        const pageIndexMobile = Math.floor(index / columnsMb);

        // Update desktop dots
        const desktopDot = this.querySelector(`.pvt-controls-dk button[data-slide="${pageIndexDesktop * columns}"]`);
        if (desktopDot) desktopDot.setAttribute('aria-selected', 'true');

        // Update mobile dots
        console.log('Mobile Dot', { pageIndexMobile, columnsMb, dataSlide: pageIndexMobile * columnsMb });
        const mobileDot = this.querySelector(`.pvt-controls-mb button[data-slide="${pageIndexMobile * columnsMb}"]`);
        if (mobileDot) mobileDot.setAttribute('aria-selected', 'true');

        // Update counter if present
        const counter = this.querySelector('[ref="current"]');
        if (counter) counter.textContent = pageIndexDesktop + 1;
      });
    }
  }
  if (!customElements.get('pivot-carousel-controls-wrapper')) {
    customElements.define('pivot-carousel-controls-wrapper', PivotCarouselControlsWrapper);
  }
  } catch(e) { console.error(e); }
})();

})();
